export const GET_CONFIG_PHS_ACTION = "GET_CONFIG_PHS_ACTION";
export const GET_CONFIG_PHS_SUCCESS = "GET_CONFIG_PHS_SUCCESS";

export const CONFIG_PHS_UPDATE_ACTION = "CONFIG_PHS_UPDATE_ACTION";
export const CONFIG_PHS_UPDATE_SUCCESS = "CONFIG_PHS_UPDATE_SUCCESS";

export const CONFIG_PHS_FAIL = "CONFIG_PHS_FAIL";